import { useState } from "react";
import TextBlocks from "../components/TextBlocks";
import SecondaryHero from "../components/SecondaryHero";
import PELTP from "../assets/images/PELTP_Data.png";
import DataHero from "../assets/images/database_hero_graphic.jpg";
import Seo from "../components/Seo";
import {
  CustomGridContainer,
  CustomPaddedContainer,
  ImageContainer,
  MyImage,
  PaddedContainer,
  FullWidthSection,
} from "../styles";
import styled from "styled-components";

const Data = () => {
  const [secondaryHeroes] = useState([
    {
      subtitle: "Data",
      heading:
        "Datasets, scrapers, pipelines: the boring infrastructure that matters",
      image: DataHero,
      imageAlt:
        "Cropped close up of a pale blue socius pattern on a bright blue background",
      id: 1,
    },
  ]);

  const [textBlocks] = useState([
    {
      captionOne: "Conference",
      captionTwo: "ICWSM 2024",
      tagOneColour: "#E6E4E2",
      tagTwoColour: "#87807B",
      heading: "sentibank",
      textColour: "#FFFFFF",
      subheading: "How Software 1.0 understood feelings",
      paragraph:
        "Sixty years of human emotion research, rescued from digital archaeology. Fifteen dictionaries. One toolkit. How Software 1.0 understood feelings before neural networks took over.",
      id: 1,
      secondaryButton: "Read the archaeology",
      secondaryLink: "/data/sentibank",
      tertiaryButton: "Install toolkit",
      tertiaryLink: "https://github.com/socius-org/sentibank",
      tertiaryTarget: "blank",
      target: "_blank",
    },
    {
      captionOne: "Conference",
      captionTwo: "AIES 2025",
      tagOneColour: "#514E4B",
      tagTwoColour: "#87807B",
      textColour: "#1C1C1E",
      subheading: "PETLP Framework",
      altParagraph:
        "Social media AI research is legally haunted. GDPR, copyright, platform terms — every pipeline step faces different rules. We mapped the maze and built the guide.",
      id: 2,
      tertiaryButton: "Read the paper",
      tertiaryLink: "https://www.arxiv.org/abs/2508.09232",
      tertiaryTarget: "_blank",
      primaryButton: "Learn the framework",
      primaryLink: "/data/peltp",
    },
    {
      captionOne: "In Development",
      tagOneColour: "#514E4B",
      tagTwoColour: "#87807B",
      textColour: "#1C1C1E",
      subheading: "RedditHarbor",
      altParagraph:
        "Reddit research has too many rules to track manually. We are building scraper that follows them all automatically. Privacy filters, audit logs, and ethical defaults built-in.",
      id: 3,
      primaryButton: "Explore the project",
      primaryLink: "/data/redditharbor",
      tertiaryButton: "Access the beta",
      tertiaryLink: "https://github.com/socius-org/RedditHarbor",
      target: "_blank",
    },
    {
      heading: "Responsible Data Pipeline",
      subheading: "Making compliance automatic",
      id: 4,
    },
  ]);

  return (
    <>
      <Seo
        title="Datasets, Scrapers, Pipelines | socius labs"
        description="Open datasets, scrapers, and pipelines for social science research. Our AI-powered dataset search matches researchers' goals with relevant data."
        image={DataHero}
        path="/data"
      />

      <SecondaryHero secondaryHeroes={secondaryHeroes} />

      <FullWidthSection bg="#292726">
        <CustomPaddedContainer>
          <TextBlocks
            textBlocks={textBlocks.filter((textBlock) => textBlock.id === 1)}
          />

          <Container>
            <WebContainer
              src="/sentibankApp.html"
              alt="An interactive Demonstration of the socius sentibank application"
              title="Interactive Mockup"
            />
          </Container>
        </CustomPaddedContainer>
      </FullWidthSection>

      <FullWidthSection bg="#E6E4E2">
        <HeadingContainer
          style={{
            backgroundColor: "#E6E4E2",
          }}
        >
          <TextBlocks
            textBlocks={textBlocks.filter((textBlock) => textBlock.id === 4)}
          />
        </HeadingContainer>

        <GreyContainer
          style={{
            backgroundColor: "#E6E4E2",
          }}
        >
          <PaddedContainer>
            <ImageContainer
              style={{
                aspectRatio: "16/9",
              }}
            >
              <MyImage
                src={PELTP}
                alt="Cropped close up of a green socius pattern on a dark green background"
              />
            </ImageContainer>
            <TextBlocks
              textBlocks={textBlocks.filter((textBlock) => textBlock.id === 2)}
            />
          </PaddedContainer>

          <PaddedContainer>
            <Container>
              <WebContainer
                src="/redditharborApp.html"
                alt="An interactive Demonstration of the socius RedditHarbor application"
                title="Interactive Mockup"
              />{" "}
            </Container>

            <TextBlocks
              textBlocks={textBlocks.filter((textBlock) => textBlock.id === 3)}
            />
          </PaddedContainer>
        </GreyContainer>
      </FullWidthSection>
    </>
  );
};

export default Data;

export const WebContainer = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: 760px;
  /* optional: ensures some initial height */
  border: 0;
  display: block;
  border-radius: 20px;
`;

export const HeadingContainer = styled(PaddedContainer)`
  padding: 60px 24px 0px 24px;
  max-width: 1681px;

  @media (max-width: 1681px) {
    margin: 0px;
  }
`;

export const GreyContainer = styled(CustomGridContainer)`
  padding: 40px 24px 60px 24px;

  @media (max-width: 1681px) {
    padding: 40px 0px;
  }

  @media (max-width: 768px) {
    /* padding: 24px 20px 60px 20px; */
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  /* aspect-ratio: 16/9; */
  overflow: hidden;
  border-radius: 20px;

  @media (max-width: 1681px) {
    /* aspect-ratio: 16/9; */
  }

  @media (max-width: 768px) {
    max-height: 640px;
  }

  @media (max-width: 414px) {
    /* aspect-ratio: 9/16; */
  }
`;
